/* Unchained Creations theme script (no dependencies) */
(function () {
  'use strict';

  var cfg = window.ucTheme || { cartType: 'drawer', routes: {} };
  var routes = cfg.routes || {};
  var toastEl = null;
  var toastTimer;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function showToast(msg) {
    toastEl = toastEl || document.getElementById('toast');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }

  /* ---------- header: dropdowns, search, mobile menu ---------- */
  function closeNavItems(except) {
    qsa('.nav-item.open').forEach(function (i) {
      if (i !== except) {
        i.classList.remove('open');
        var c = qs('.nav-caret, .nav-parent', i);
        if (c) c.setAttribute('aria-expanded', 'false');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var caret = e.target.closest('.nav-caret, .nav-parent');
    if (caret) {
      var item = caret.closest('.nav-item');
      var wasOpen = item.classList.contains('open');
      closeNavItems();
      if (!wasOpen) {
        item.classList.add('open');
        caret.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.nav-item')) closeNavItems();

    var acc = e.target.closest('[data-accordion]');
    if (acc) {
      var parent = acc.parentElement;
      var isOpen = parent.classList.toggle('open');
      acc.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    if (e.target.closest('[data-open-mobile]')) { setMobile(true); return; }
    if (e.target.closest('[data-close-mobile]')) { setMobile(false); return; }

    var searchBtn = e.target.closest('[data-toggle-search]');
    if (searchBtn) {
      var bar = qs('[data-search-bar]');
      if (bar) {
        var show = bar.hasAttribute('hidden');
        if (show) { bar.removeAttribute('hidden'); } else { bar.setAttribute('hidden', ''); }
        searchBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) { var inp = qs('input[type="search"]', bar); if (inp) inp.focus(); }
      }
      return;
    }
  });

  function setMobile(open) {
    var panel = qs('[data-mobile-panel]');
    if (!panel) return;
    panel.classList.toggle('active', open);
    var b = qs('[data-open-mobile]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setMobile(false);
      setCart(false);
      closeNavItems();
    }
  });

  /* ---------- cart drawer ---------- */
  function setCart(open) {
    var panel = qs('[data-cart-panel]');
    if (!panel) return;
    panel.classList.toggle('active', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = qs('.cart-head .icon-btn', panel);
      if (close) close.focus();
    }
  }

  function updateCartCount(n) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function applyCartSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newPanel = qs('[data-cart-panel]', doc);
    var panel = qs('[data-cart-panel]');
    if (newPanel && panel) {
      var wasActive = panel.classList.contains('active');
      var sheet = qs('.cart-sheet', panel);
      var newSheet = qs('.cart-sheet', newPanel);
      if (sheet && newSheet) { sheet.innerHTML = newSheet.innerHTML; }
      if (wasActive) panel.classList.add('active');
    }
    var src = qs('[data-cart-count-source]', doc);
    if (src) updateCartCount(src.textContent.trim());
  }

  function cartRequest(url, payload) {
    payload.sections = 'cart-drawer';
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not update the cart.');
          throw err;
        }
        return data;
      });
    });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.disabled = true;
    return cartRequest(routes.cartAdd, { id: Number(id), quantity: Number(qty) || 1 })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) applyCartSection(data.sections['cart-drawer']);
        if (cfg.cartType === 'drawer') { setCart(true); } else { showToast('Added to cart'); }
        return data;
      })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var openCartBtn = e.target.closest('[data-cart-open]');
    if (openCartBtn && cfg.cartType === 'drawer' && qs('[data-cart-panel]')) {
      e.preventDefault();
      setCart(true);
      return;
    }
    if (e.target.closest('[data-close-cart]')) { setCart(false); return; }

    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      addToCart(qa.getAttribute('data-variant-id'), 1, qa).catch(function (err) { showToast(err.message); });
      return;
    }

    var chg = e.target.closest('[data-qty-change]');
    if (chg) {
      e.preventDefault();
      cartRequest(routes.cartChange, { line: Number(chg.getAttribute('data-line')), quantity: Number(chg.getAttribute('data-qty')) })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) applyCartSection(data.sections['cart-drawer']);
        })
        .catch(function (err) { showToast(err.message); });
    }
  });

  /* ---------- quantity steppers (product + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && qs('[data-qty-input]', wrap);
    if (!input) return;
    var min = input.getAttribute('min') === '0' ? 0 : 1;
    var next = (parseInt(input.value, 10) || min) + Number(step.getAttribute('data-qty-step'));
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  function initProduct(section) {
    var jsonEl = qs('[data-product-json]', section);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = qs('.product-form', section);
    if (!form) return;
    var idInput = qs('[data-variant-id]', form);
    var addBtn = qs('[data-add-btn]', form);
    var addLabel = qs('[data-add-label]', form);
    var priceEl = qs('[data-product-price]', section);
    var errEl = qs('[data-form-error]', form);
    var qtyInput = qs('[data-qty-input]', form);

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      try {
        var f = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: f }).format(cents / 100);
      } catch (err) { return '$' + v; }
    }

    function selectedOptions() {
      var groups = qsa('.option-group', form);
      return groups.map(function (g) {
        var checked = qs('input[data-option]:checked', g);
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      if (!product.variants || !product.variants.length) return null;
      var hasPickers = qsa('.option-group', form).length > 0;
      if (!hasPickers) return product.variants[0];
      var sel = selectedOptions();
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function showSlide(mediaId) {
      qsa('[data-slide]', section).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId)); });
      qsa('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId)); });
    }

    function update() {
      var v = findVariant();
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = '<span class="price-sale">' + money(v.price) + '</span> <s class="price-reg">' + money(v.compare_at_price) + '</s>';
        } else {
          priceEl.innerHTML = '<span class="price-now">' + money(v.price) + '</span>';
        }
      }
      if (v.featured_media && v.featured_media.id) showSlide(v.featured_media.id);
      if (product.variants.length > 1 && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option]')) update();
    });

    form.addEventListener('submit', function (e) {
      if (cfg.cartType !== 'drawer' || !routes.cartAdd) return;
      e.preventDefault();
      if (errEl) { errEl.hidden = true; }
      addToCart(idInput.value, qtyInput ? qtyInput.value : 1, addBtn).catch(function (err) {
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    });

    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showSlide(t.getAttribute('data-media-id'));
    });

    update();
  }
  qsa('[data-product-section]').forEach(initProduct);

  /* ---------- related products (Product Recommendations API) ---------- */
  qsa('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = qs('[data-related-section]', doc);
        if (sec) el.replaceWith(sec);
      })
      .catch(function () {});
  });

  /* ---------- collection filters ---------- */
  var collForm = qs('[data-collection-form]');
  if (collForm) {
    var submitTimer;
    collForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-auto-submit]')) {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () { collForm.submit(); }, 250);
      }
    });
    var ft = qs('[data-filter-toggle]', collForm);
    var fl = qs('[data-filters]', collForm);
    if (ft && fl) {
      ft.addEventListener('click', function () {
        var open = fl.classList.toggle('open');
        ft.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---------- cart page quantity auto-update ---------- */
  var cartPageForm = qs('#CartPageForm');
  if (cartPageForm) {
    var cartTimer;
    cartPageForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) {
        clearTimeout(cartTimer);
        cartTimer = setTimeout(function () {
          var u = document.createElement('input');
          u.type = 'hidden'; u.name = 'update'; u.value = 'Update';
          cartPageForm.appendChild(u);
          cartPageForm.submit();
        }, 500);
      }
    });
  }

  /* ---------- login / recover toggle ---------- */
  var recoverLink = qs('[data-show-recover]');
  var backLink = qs('[data-hide-recover]');
  var loginPanel = qs('[data-login-panel]');
  var recoverPanel = qs('[data-recover-panel]');
  function toggleRecover(show) {
    if (!loginPanel || !recoverPanel) return;
    loginPanel.hidden = show;
    recoverPanel.hidden = !show;
  }
  if (recoverLink) recoverLink.addEventListener('click', function (e) { e.preventDefault(); toggleRecover(true); });
  if (backLink) backLink.addEventListener('click', function (e) { e.preventDefault(); toggleRecover(false); });
  if (recoverPanel && qs('.form-success', recoverPanel)) toggleRecover(true);

  /* ---------- address book ---------- */
  document.addEventListener('click', function (e) {
    var tgl = e.target.closest('[data-toggle-address]');
    if (tgl) {
      var panel = document.getElementById('address-edit-' + tgl.getAttribute('data-toggle-address'));
      if (panel) panel.hidden = !panel.hidden;
    }
    var del = e.target.closest('[data-delete-address]');
    if (del && window.confirm('Delete this address?')) {
      var card = del.closest('.address-card');
      var token = card && qs('input[name="authenticity_token"]', card);
      var f = document.createElement('form');
      f.method = 'post';
      f.action = del.getAttribute('data-delete-address');
      var m = document.createElement('input');
      m.type = 'hidden'; m.name = '_method'; m.value = 'delete';
      f.appendChild(m);
      if (token) {
        var t = document.createElement('input');
        t.type = 'hidden'; t.name = 'authenticity_token'; t.value = token.value;
        f.appendChild(t);
      }
      document.body.appendChild(f);
      f.submit();
    }
  });

  /* ---------- scroll reveal (content is visible without it) ---------- */
  var reveals = qsa('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }
})();
